<template>
  <div ref="wrapper" :style="styleWrapper" class="messages_wrapper">
    <WinFreeBetMessage v-if="popups.winFreeBet"></WinFreeBetMessage>
    <DistributionFreeBets v-if="popups.freeBetsStarted"></DistributionFreeBets>
    <DistributionFinishedFreeBets v-if="popups.freeBetsFinished"></DistributionFinishedFreeBets>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import WinFreeBetMessage from '@/components/messages/messages/WinFreeBetMessage.vue';
import DistributionFreeBets from '@/components/messages/messages/DistributionFreeBets.vue';
import DistributionFinishedFreeBets from '@/components/messages/messages/DistributionFinishedFreeBets.vue';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'MessageWrapper',
  components: {
    WinFreeBetMessage,
    DistributionFreeBets,
    DistributionFinishedFreeBets
  },
  data: () => ({
    isShow: false,
    timeClose: 5000,
    popups: {
      winFreeBet: false,
      freeBetsStarted: false,
      freeBetsFinished: false
    },
    timeIdClose: 0,
    nextMessages: []
  }),
  watch: {
    isShowFreeBetWinPopup: function (): void {
      if (this.isShowFreeBetWinPopup && this.isShowPopup('winFreeBet')) return;
      this.changedStatus(this.isShowFreeBetWinPopup);
      if (this.isShowFreeBetWinPopup)
        this.timeIdClose = setTimeout(this.closeMessage.bind(this, 'winFreeBet'), this.timeClose);
    },
    isShowFreeBetStarted: function (): void {
      if (this.isShowFreeBetStarted && this.isShowPopup('freeBetStarted')) return;
      this.changedStatus(this.isShowFreeBetStarted);
      if (this.isShowFreeBetStarted)
        this.timeIdClose = setTimeout(this.closeMessage.bind(this, 'freeBetStarted'), this.timeClose);
    },
    isShowFreeBetFinished: function (): void {
      if (this.isShowFreeBetFinished && this.isShowPopup('freeBetFinished')) return;
      this.changedStatus(this.isShowFreeBetFinished);
      if (this.isShowFreeBetFinished)
        this.timeIdClose = setTimeout(this.closeMessage.bind(this, 'freeBetFinished'), this.timeClose);
    }
  },
  methods: {
    isShowPopup(type: string): boolean {
      if (!this.isShow) return false;
      // @ts-ignore
      this.nextMessages.push(type);
      return true;
    },
    changedStatus(status: boolean): void {
      if (status) {
        switch (true) {
          case this.isShowFreeBetWinPopup:
            this.popups.winFreeBet = true;
            break;
          case this.isShowFreeBetStarted:
            this.popups.freeBetsStarted = true;
            break;
          case this.isShowFreeBetFinished:
            this.popups.freeBetsFinished = true;
        }
        this.isShow = true;

        // кастыль нужен чтоб заново вызвать computed styleWrapper
        setTimeout(() => {
          this.isShow = false;
          this.isShow = true;
        }, 200);
      } else {
        this.clearTimer();
        setTimeout(() => {
          this.popups.winFreeBet = false;
          this.popups.freeBetsStarted = false;
          if (this.nextMessages.length > 0) {
            this.changedStatus(true);
            this.timeIdClose = setTimeout(this.closeMessage.bind(this, this.nextMessages[0]), this.timeClose);
            this.nextMessages = this.nextMessages.slice(1);
          }
        }, 500);
      }
    },
    closeMessage(type: string): void {
      this.clearTimer();
      setTimeout(() => {
        promoApp.store.dispatch(ACTION.SET_MESSAGE_VISIBLE, { visible: false, type });
      }, 500);
    },
    clearTimer(): void {
      this.isShow = false;
      clearTimeout(this.timeIdClose);
      this.timeIdClose = 0;
    }
  },
  computed: {
    ...mapGetters(['getFreeBetWin', 'getAppConfiguration', 'isLandscape', 'getFreeBetStarted', 'getFreeBetFinished']),
    isShowFreeBetWinPopup(): boolean {
      return this.getFreeBetWin.isShow;
    },
    isShowFreeBetStarted(): boolean {
      return this.getFreeBetStarted.isShow;
    },
    isShowFreeBetFinished(): boolean {
      return this.getFreeBetFinished.isShow;
    },
    styleWrapper(): any {
      const scale: number = this.uiScale;
      const addScale: number = this.isLandscape ? 1.5 : 2;
      const finalScale = scale * addScale;
      const offset: any = {
        width: this.isLandscape ? 600 : 450,
        height: (<HTMLElement>this.$refs.wrapper)?.offsetHeight
      };
      return {
        transform: `scale(${finalScale})`,
        left: `calc(50% - ${offset.width / 2}px)`,
        top: this.isShow ? -(offset.height - offset.height * finalScale) / 2 + 'px' : -100 + '%',
        width: offset.width + 'px'
      };
    },
    uiScale(): number {
      return this.getAppConfiguration.scale;
    }
  }
});
</script>

<style lang="scss" scoped>
.messages_wrapper {
  display: flex;
  justify-content: center;
  position: fixed;
  font-family: 'myriadpro-bold', sans-serif;
  transition: all 0.7s ease;
}
</style>
